import React, {useEffect, useState} from 'react'
import Mapa from './Mapa'
import Tabla from './Tabla'
import axios from 'axios';
import qs from 'qs';
import { authUser } from '../funciones/AuthUser'
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import IntervaloSelect from './IntervaloTabla';
import {Box, Button, LinearProgress,FormControl, InputLabel, Select, MenuItem,
     RadioGroup, Radio,
     FormControlLabel, 
 } from "@material-ui/core";
import {llamaApiCargaToken,llamadaApiToken,ErrorGeneral } from '../funciones/ClienteAxios';
import { ordenMapBx } from '../MapaEdo/OrdenxMapBox';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment';
import CardPerfil from './CardPerfil';
const MapaEncuesta =()=>{
    const history = useHistory();
    const source = axios.CancelToken.source();
    const auxId =localStorage.getItem('UsuId') ; 
    const nvl= localStorage.getItem('Tipo')?parseInt(localStorage.getItem('Tipo')):0; 
    const Dispvo =localStorage.getItem('Dispvo') ;       
    const auxDispV =Dispvo && Dispvo.length >= 12 ? Dispvo:'w8rf51v21dsd2cs' 
    const {usuario,guardarUsuario}=React.useContext(AuthContext);
    const {generales,guardarGenerales}=React.useContext(GeneralesContext);    
    const [fSelect, setFSelect] = useState({inicio:new Date(),final:new Date()});
    const [lista, setLista]= useState([])
    const [espera,setEspera]= useState(false);
    const [bandera, setBandera]= useState(true)
    const [contador, setContador] = useState(1);
    const [periodo,setPeriodo]= useState("1A");  
    const [listDistrito,setListDistrito]= useState([]);  
    const [listPoliDto, setListPoliDto]= useState([]);  
    const [listPoliOtb, setListPoliOtb]= useState([]); 
    const [listColOtb, setListColOtb]= useState([]); 
    const [listColPolig, setListColPolig]= useState([]); 
    const [listMarcador, setListMarcador]= useState([]);   
    const [listNumOtb, setListNumOtb]= useState([]);   
    const [listEleccion, setListEleccion]= useState([]);   
    const [listTotal, setListTotal]= useState([]);   
    const [distrito, setDistrito]= useState([]);      
    const [listMarcaEncuesta, setListMarcaEncuesta]=useState([]);
    const [mapEncuesta, setMapEncuesta]=useState(false);
    const [cargaTotal, setCargaTotal]=useState(false);

        useEffect(()=>{             
            const autenticado = authUser();
            if(!autenticado){
                localStorage.clear();
                history.push("/");
                guardarUsuario([])
            }
            else
            {   const usu= localStorage.getItem('UsuarioNom');                 
                if (usuario.length===0) 
                {
                    guardarUsuario({Nombre:usu,nivel:nvl});                                                               
                }                      
                
                getListDto()
        
                guardarGenerales({...generales,Titulo:'Mapa Encuestas'})                          
            }
            
            return ()=> {
                source.cancel();
            }      
        //la siguiente linea puede generar errores o no en el useEffect
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

 
    function getListDto()  {            
        const auxU= `lugar/municipio/distrito`;                            
        const dataInfo = qs.stringify({                
            Usuario:auxId,     
            Estado: process.env.REACT_APP_EDO,  ip:"127.0.0.0",                      
            idDispositivo:auxDispV,
            });
                    
        function respuesta (auxiliar) 
        {   if (auxiliar[0].Id !== -1) 
            {   let listNvo=[]
                auxiliar.forEach(element => {
                    listNvo.push({...element, cadena:`D${element.Nom} - ${element.ComNom}`})
                });                                                 
                setListDistrito(listNvo) 
            }                                                            
        }
        llamadaApiToken(dataInfo, auxU, respuesta, ErrorGeneral,  history, source);
    };
    
    const getListPoliDto = (Distrito) => {
        const data = qs.stringify({ ip:"127.0.0.0",  
            Usuario: auxId, Distrito:Distrito,   idDispositivo: auxDispV,
        });
        const url = "lugar/municipio/distrito/gps";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].id != -1) {               
                let auxArr=[]
              //  console.log([auxiliar[0].Ln.toFixed(5), auxiliar[0].Lat.toFixed(5)]);
                auxiliar.forEach((poligono)=>{                                        
                  auxArr.push([poligono.Ln, poligono.Lt])
                  //auxArr.push({coordinates:[poligono.Ln, poligono.Lt]})
                })
                //console.log(auxArr);
                
                setListPoliDto(auxArr)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListPoliOtb = (Distrito) => {
        const data = qs.stringify({ ip:"127.0.0.0",  
            Usuario: auxId, Distrito:Distrito,   idDispositivo: auxDispV,
        });
        const url = "lugar/municipio/distrito/otb/gps";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].id != -1) {               
                let auxArr2=[], auxArr3=[], auxListOtb=[], auxCol=[]                              
                    
                auxCol=["match",["get", "IdOTB"]]
                auxiliar[0].otb.forEach((element)=>{
                    let nvoArr=[]
                    if (element.gps) {
                        element.gps.forEach((poligono)=>{
                            nvoArr.push([poligono.Ln, poligono.Lt])
                        })     
                        
                        auxArr2.push({ 
                            "id":element.Id,
                            'type': 'Feature',
                            "properties":{
                                "IdOTB":element.Id, 
                                "colOtb":element.Col
                            },
                            "nomOtb":element.Nom,                                
                            'geometry': {                        
                                'type': 'MultiPolygon',                         
                                'coordinates': [[nvoArr]]
                            }
                        })
                        auxCol.push(element.Id)      
                        auxCol.push(element.Col)  
                        auxListOtb.push({...element, coordinates:[element.Ln, element.Lt]})         
                    }
                    
                })                    
                auxCol.push('#cedded')                   
                    
                auxArr3={"type": "FeatureCollection",
                    "name": "Cochabamba",
                    "features":auxArr2}
             
                setListNumOtb(auxListOtb)
                setListColPolig(auxCol)                                                   
                setListPoliOtb(auxArr3)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListMarcador = (Distrito) => {
        const data = qs.stringify({ ip:"127.0.0.0",  
            Usuario: auxId, Distrito:Distrito,   idDispositivo: auxDispV,
        });
        const url = "lugar/recinto/dto";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].id != -1) {               
                let auxArr=[]              
                auxiliar.forEach((poligono)=>{                                        
                  auxArr.push({coordinates:[poligono.ln, poligono.lt], original:poligono})                  
                })                
                setListMarcador(auxArr)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListMapDet = (  dtoReg) => {
        const fInicio=moment(fSelect.inicio).format("YYYY-MM-DD");
        const fFinal=moment(fSelect.final).format("YYYY-MM-DD");  
        //console.log(fInicio,fSelect2.inicio);
        
        const data = qs.stringify({
          Usuario:auxId,           
          Distrito:dtoReg,          
          FIni:`${fInicio}T00:00:00`,
          FFin:`${fFinal}T23:59:59`,
          ip:"127.0.0.0", idDispositivo: auxDispV,
        });
        const url = "perfil/v1/mapa/sondeo";
    
        function respuesta(auxiliar) {
         // changeBandera2(true) 
            if (auxiliar[0].Id !== -1) {
                let nvoArr=[]
                auxiliar.forEach((marcador)=>{
                    nvoArr.push({coordinates:[marcador.Ln, marcador.Lt], original:marcador})
                })
                setListMarcaEncuesta(nvoArr)
            }
          
        }
    
        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setMapEncuesta, history, source);
    }

      const getListTotal = () => {
        const fInicio=moment(fSelect.inicio).format("YYYY-MM-DD");
        const fFinal=moment(fSelect.final).format("YYYY-MM-DD");      
        const data = qs.stringify({
          Usuario:auxId, Edo:15, Muni:40,
          FIni:`${fInicio}T00:00:00`,FFin:`${fFinal}T23:59:59`,    
          ip:"127.0.0.0", idDispositivo: auxDispV,
        });
        const url = "perfil/v2/adm/dashboard/det";
     
        function respuesta(auxiliar) {
          if (auxiliar[0].Id !== -1) {        
             const auxArr=auxiliar[0].total[0]
            //setContadorTotal(auxArr.GenBinario + auxArr.GenHombre + auxArr.GenMujer)
            return setListTotal(auxArr)
          }
        }
    
        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargaTotal, history, source);
    }

    const getListEleccion = (Distrito) => {
        const data = qs.stringify({ ip:"127.0.0.0",  Periodo:periodo,
            Usuario: auxId, Dto:Distrito,   idDispositivo: auxDispV,
        });
        const url = "eleccciones/bolivia/resultado/dto/otb";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].id != -1) {               
                let  auxCol=[], listCol=[]         
                auxCol=["match",["get", "IdOTB"]]     
                auxiliar.forEach((poligono)=>{                                        
                    ordenMapBx(listCol, poligono.Otb, poligono.Col)             
                })
                listCol.forEach((elemento)=>{
                    auxCol.push(elemento.pos)
                    auxCol.push(elemento.auxColor)
                    //cuenta=cuenta+elemento.pos.length
                })  
                auxCol.push('#cedded')
                setListEleccion(auxiliar)                 
                setListColOtb(auxCol)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const limpiar =()=>{
        localStorage.removeItem("auxPol")
        setBandera(false)
        setLista([])
        setContador(1)
    }

    const funcionUltimo =()=>{
        let auxLocalStg =  localStorage.getItem('auxPol') ?  JSON.parse(localStorage.getItem('auxPol')):[]
        if (auxLocalStg.length!==0) {
            if (auxLocalStg.length===1) {
                limpiar()
            }
            else{
                auxLocalStg.pop()
                localStorage.setItem('auxPol',JSON.stringify(auxLocalStg))
                setContador(contador-1)
                setBandera(false)
            }            
        }        
    }

    const onChangeRad=(e)=>{
       setPeriodo( e.target.value)                                                           
    }

    const onChangeDto=(e)=>{    
        if (e!== null && e!== undefined) 
        { //setMuniSelect(e)               
            setDistrito(e.target.value)    
            setListPoliDto([])
            setListPoliOtb([])
            setListMarcador([])
            getListPoliDto(e.target.value)  
            getListPoliOtb(e.target.value)  
            getListMarcador(e.target.value)  
            getListMapDet(e.target.value)
            getListTotal()
           // getListEleccion(e.target.value)
          
            
        }else
        {   setDistrito("")           
        }               
    } 

     const generarLista=( )=>{    
        if (distrito.length!==0) 
        {  
            setListPoliDto([])
            setListPoliOtb([])
            setListMarcador([])
            getListPoliDto(distrito)  
            getListPoliOtb(distrito)  
            getListMarcador(distrito)  
            getListMapDet(distrito)
            getListTotal()
          //  getListEleccion(distrito)
            
        }             
    } 

    return(
    <Box display={"flex"} flexDirection={"column"}>
        <Box display={"flex"} flexDirection={"row"}>
            <Box mr={1} >       
                <Button onClick={generarLista} style={{width:"7rem", marginTop:".5rem", backgroundColor:process.env.REACT_APP_Btn_Color}}  
                    variant="contained"  color="primary"  startIcon={<SearchIcon/>} 
                    disabled={espera}
                >   
                    Buscar     
                </Button>                                                                                                                        
            </Box>   
            { listDistrito.length!==0 ?                
                <Box display={"flex"} mb={2} mt={1}>
                <FormControl size='small'  style={{ minWidth:14+'rem'}} >
                    <InputLabel size='small' variant="outlined" id="distrito-label-nvo">Distrito</InputLabel>
                    <Select  size='small' variant="outlined"    
                        label="Distrito" id="Distrito-select2" name="distrito"
                        value={distrito} onChange={onChangeDto}
                    >
                    {listDistrito.map((secc, index) => {
                        if(secc.Id>0) {
                        return(
                        <MenuItem size='small' value={secc.Id} key={secc.Id}>
                            <em>{secc.cadena }</em>
                        </MenuItem>
                        )}
                    } )}                    
                    </Select>
                </FormControl>
                </Box>
            :   null
            }
            <Box display={"flex"} ml={1}>
                <IntervaloSelect fSelect={fSelect}  setFSelect={setFSelect} />              
            </Box>
            {/* <FormControl component="fieldset" style={{marginLeft:.5+'rem', marginTop:".5rem" }}>          
                
                <RadioGroup  row aria-label="position"  defaultValue="top"
                    name="periodo" value={periodo} onChange={onChangeRad}
                >                        
                    <FormControlLabel value={"1A"}  label={"Primer Periodo"}
                        style={{}}
                        control={<Radio color="primary" />} />
                    <FormControlLabel value={"2A"}  label={"Segundo Periodo"}
                        style={{}}
                        control={<Radio color="primary" />} />                                                                      
                </RadioGroup>                     
            </FormControl>   */}
            {listTotal.length !== 0 ? 
                <CardPerfil listTotal={listTotal} dtoRegistro={distrito} />
            :null}  
        </Box>        
        <Box  ml={1}>
            {!espera && listPoliDto.length!==0 && listMarcador.length!==0 && listPoliOtb.length!==0 
                && listMarcaEncuesta!==0
                //&& listColOtb.length !== 0
             ? 
                <Mapa lista={listPoliDto} setLista={setLista} setActualiza={()=>setBandera(!bandera)} 
                    contador={contador} setContador={setContador} listMarcador={listMarcador} 
                    listPoliOtb={listPoliOtb} listColOtb={listColOtb} listNumOtb={listNumOtb}
                    listColPolig={listColPolig} listEleccion={listEleccion} listMarcaEncuesta={listMarcaEncuesta}
                />
            : espera ?<Box mt={5}><LinearProgress/></Box>:null}
        </Box>
        
    </Box>)
}

export default MapaEncuesta